// src/store/slices/inquiriesSlice.js

import { createSlice } from '@reduxjs/toolkit';

const inquiriesSlice = createSlice({
  name: 'inquiries',
  initialState: {
    list: [],
    current: null,
    loading: false,
    error: null,
  },
  reducers: {
    fetchInquiriesPending:    state => { state.loading = true; state.error = null; },
    fetchInquiriesFulfilled:  (state, { payload }) => { state.loading = false; state.list = payload; },
    fetchInquiriesRejected:   (state, { payload }) => { state.loading = false; state.error = payload; },

    fetchInquiryPending:      state => { state.loading = true; state.error = null; },
    fetchInquiryFulfilled:    (state, { payload }) => { state.loading = false; state.current = payload; },
    fetchInquiryRejected:     (state, { payload }) => { state.loading = false; state.error = payload; },

    createInquiryPending:     state => { state.loading = true; state.error = null; },
    createInquiryFulfilled:   (state, { payload }) => { state.loading = false; state.list.unshift(payload); },
    createInquiryRejected:    (state, { payload }) => { state.loading = false; state.error = payload; },

    replyInquiryPending:      state => { state.loading = true; state.error = null; },
    replyInquiryFulfilled:    (state, { payload }) => {
                                 state.loading = false;
                                 // update current and list
                                 state.current = payload;
                                 state.list = state.list.map(i => i._id === payload._id ? payload : i);
                               },
    replyInquiryRejected:     (state, { payload }) => { state.loading = false; state.error = payload; },

    updateInquiryPending:     state => { state.loading = true; state.error = null; },
    updateInquiryFulfilled:   (state, { payload }) => {
                                 state.loading = false;
                                 state.current = payload;
                                 state.list = state.list.map(i => i._id === payload._id ? payload : i);
                               },
    updateInquiryRejected:    (state, { payload }) => { state.loading = false; state.error = payload; },
  }
});

export const {
  fetchInquiriesPending,
  fetchInquiriesFulfilled,
  fetchInquiriesRejected,
  fetchInquiryPending,
  fetchInquiryFulfilled,
  fetchInquiryRejected,
  createInquiryPending,
  createInquiryFulfilled,
  createInquiryRejected,
  replyInquiryPending,
  replyInquiryFulfilled,
  replyInquiryRejected,
  updateInquiryPending,
  updateInquiryFulfilled,
  updateInquiryRejected,
} = inquiriesSlice.actions;

export default inquiriesSlice.reducer;
